<template>
  <v-container>
    <v-row class="text-center" v-if="loading">
      <v-progress-circular
        class="mx-auto loader"
        indeterminate
        color="orange"
        size="75"
      ></v-progress-circular>
    </v-row>

    <v-row v-else>
      <v-col cols="12" md="4">
        <v-card>
          <v-img :src="profile.picture" width="100%" />
          <v-card-title class="d-block text-center">
            {{ profile.firstName }} {{ profile.lastName }}
          </v-card-title>
          <v-card-actions>
            <v-btn block text color="orange" @click="edit('picture')"
              >Change Picture</v-btn
            >
          </v-card-actions>
        </v-card>
        <v-card class="mt-6">
          <v-card-actions>
            <v-btn
              block
              dark
              text
              color="green"
              class="float-right"
              @click="edit('share')"
            >
              Share Profile
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card class="mt-6">
          <v-card-actions>
            <v-btn
              block
              dark
              text
              color="red"
              class="float-right"
              @click="edit('delete')"
            >
              Delete Profile
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12" md="8">
        <v-card>
          <v-card-title>About</v-card-title>
          <v-card-text>
            {{ profile.about }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="profile.video"
              text
              color="green"
              @click="edit('video')"
              >Video</v-btn
            >
            <v-btn text color="orange" @click="edit('about')">Edit</v-btn>
          </v-card-actions>
        </v-card>
        <v-card class="mt-6">
          <v-card-title>Hobbies/Movies/Music/Books</v-card-title>
          <v-card-text>
            <v-chip
              class="ma-2"
              color="blue darken-4"
              text-color="white"
              v-for="(interest, index) in profile.interests"
              :key="index"
            >
              {{ interest }}
              <v-icon right size="16" @click="removeInterest(index)">
                mdi-delete
              </v-icon>
            </v-chip>
          </v-card-text>
          <v-card-actions>
            <v-text-field
              v-model="form.interest"
              label="Add Interest"
              class="mt-6"
            ></v-text-field>
            <v-btn text color="orange" @click="saveInterest" class="mt-6"
              >Add</v-btn
            >
          </v-card-actions>
        </v-card>
        <v-card class="mt-6">
          <v-card-title>
            Information
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="6" md="3">
                  <h3 class="caption font-weight-bold">City</h3>
                  <h2 class="body-1">{{ profile.city || "Not Specified" }}</h2>
                </v-col>
                <v-col cols="6" md="3">
                  <h3 class="caption font-weight-bold">State</h3>
                  <h2 class="body-1">{{ profile.state || "Not Specified" }}</h2>
                </v-col>
                <v-col cols="6" md="3">
                  <h3 class="caption font-weight-bold">Zip</h3>
                  <h2 class="body-1">{{ profile.zip || "Not Specified" }}</h2>
                </v-col>
                <v-col cols="6" md="3">
                  <h3 class="caption font-weight-bold">Received Diagnosis</h3>
                  <h2 class="body-1">
                    {{ profile.diagnosed || "Not Specified" }}
                  </h2>
                </v-col>
              </v-row>
              <v-row class="mt-6">
                <v-col cols="6" md="3">
                  <h3 class="caption font-weight-bold">Has Insurance</h3>
                  <h2 class="body-1">
                    {{ profile.insurance || "Not Specified" }}
                  </h2>
                </v-col>
                <v-col cols="6" md="3">
                  <h3 class="caption font-weight-bold">Insurance Provider</h3>
                  <h2 class="body-1">
                    {{ profile.provider || "Not Specified" }}
                  </h2>
                </v-col>
                <v-col cols="6" md="3">
                  <h3 class="caption font-weight-bold">
                    Received Early Intervention
                  </h3>
                  <h2 class="body-1">
                    {{ profile.intervention || "Not Specified" }}
                  </h2>
                </v-col>
                <v-col cols="12" md="3">
                  <h3 class="caption font-weight-bold">Goals</h3>
                  <h2 class="body-1">{{ profile.goals || "Not Specified" }}</h2>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="orange" @click="edit('information')">Edit</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog scrollable v-model="dialog.picture" max-width="600px">
      <v-card>
        <v-card-title class="dark-background white--text">
          Change Picture
        </v-card-title>
        <v-card-text class="mt-6">
          <v-file-input v-model="form.picture" label="Picture"></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="dialog.picture = false"
            >Cancel</v-btn
          >
          <v-btn text color="orange" @click="savePicture">
            <v-progress-circular
              v-if="saving"
              indeterminate
              color="orange"
            ></v-progress-circular>
            <span v-else>Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="dialog.share" max-width="600px">
      <v-card>
        <v-card-title class="dark-background white--text">
          Share Profile
        </v-card-title>
        <v-card-text class="mt-6">
          <v-text-field v-model="form.share" label="Email"></v-text-field>
          <p v-if="!userFound" class="mt-1 body-1 red--text">
            User does not exist
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="cancelShare">Cancel</v-btn>
          <v-btn text color="orange" @click="submitShare">
            <v-progress-circular
              v-if="saving"
              indeterminate
              color="orange"
            ></v-progress-circular>
            <span v-else>Share</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="dialog.about" max-width="600px">
      <v-card>
        <v-card-title class="dark-background white--text">
          Edit About
        </v-card-title>
        <v-card-text class="mt-6">
          <v-file-input
            v-model="form.video"
            label="Video (Optional)"
          ></v-file-input>
          <v-textarea v-model="form.about" label="About"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="dialog.about = false">Cancel</v-btn>
          <v-btn text color="orange" @click="saveAbout">
            <v-progress-circular
              v-if="saving"
              indeterminate
              color="orange"
            ></v-progress-circular>
            <span v-else>Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="dialog.information" max-width="600px">
      <v-card>
        <v-card-title class="dark-background white--text">
          Edit Information
        </v-card-title>
        <v-card-text class="mt-6">
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="form.city" label="City"></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete
                  v-model="form.state"
                  :items="states"
                  label="State"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field v-model="form.zip" label="Zip"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  v-model="form.diagnosed"
                  :items="['Yes', 'No']"
                  label="Received Diagnosis"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="form.intervention"
                  :items="['Yes', 'No']"
                  label="Received Early Intervention"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  v-model="form.insurance"
                  :items="['Yes', 'No']"
                  label="Has Insurance"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.provider"
                  label="Insurance Provider"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="form.goals"
                  label="What are your desired goals?"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="dialog.information = false"
            >Cancel</v-btn
          >
          <v-btn text color="orange" @click="saveInformation">
            <v-progress-circular
              v-if="saving"
              indeterminate
              color="orange"
            ></v-progress-circular>
            <span v-else>Save</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="dialog.delete" max-width="600px">
      <v-card>
        <v-card-title class="red white--text">
          Are you sure?
        </v-card-title>
        <v-card-text class="mt-6">
          This will delete all documents, notes, and achievements for this
          profile. This operation cannot be undone.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="dialog.delete = false">Cancel</v-btn>
          <v-btn text color="red" @click="removeProfile">
            <v-progress-circular
              v-if="saving"
              indeterminate
              color="red"
            ></v-progress-circular>
            <span v-else>Delete</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="dialog.video" max-width="600px">
      <v-card>
        <v-card-title class="dark-background white--text">
          {{ profile.firstName }} {{ profile.lastName }}
        </v-card-title>
        <v-card-text class="mt-6">
          <vue-player :src="profile.video" v-model="playing"></vue-player>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="orange" @click="closeVideo()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import vuePlayer from "@algoz098/vue-player";

export default {
  name: "Profile",
  components: { vuePlayer },
  props: ["id"],
  data() {
    return {
      loading: true,
      profileID: this.id,
      dialog: {
        about: false,
        delete: false,
        information: false,
        picture: false,
        share: false,
        video: false,
      },
      form: {
        about: null,
        picture: null,
        interest: null,
        city: null,
        state: null,
        zip: null,
        diagnosed: null,
        insurance: null,
        provider: null,
        intervention: null,
        goals: null,
        video: null,
        share: null
      },
      playing: false,
      saving: false,
      userFound: true
    };
  },
  computed: {
    ...mapGetters({
      profile: "profiles/getProfile",
      states: "resources/getStates",
    }),
  },
  methods: {
    ...mapActions({
      initProfile: "profiles/initProfile",
      deleteProfile: "profiles/deleteProfile",
      shareProfile: "profiles/shareProfile",
      updatePicture: "profiles/updatePicture",
      updateProfile: "profiles/updateProfile",
      updateVideo: "profiles/updateVideo",
    }),
    cancelShare() {
      this.userFound = true;
      this.dialog.share = false;
    },
    closeVideo() {
      this.dialog.video = false;
      this.playing = false;
    },
    edit(section) {
      this.dialog[section] = true;
    },
    async removeInterest(index) {
      this.profile.interests.splice(index, 1);
      await this.updateProfile({
        interests: this.profile.interests,
        id: this.profileID,
      });
    },
    async removeProfile() {
      this.saving = true;
      await this.deleteProfile(this.profileID);
      this.$router.push({ name: "profiles" });
    },
    async saveAbout() {
      this.saving = true;
      await this.updateProfile({
        about: this.form.about,
        id: this.profileID,
      });
      if (this.form.video) {
        await this.updateVideo({
          file: this.form.video,
          id: this.profileID,
        });
      }
      this.saving = false;
      this.dialog.about = false;
    },
    async saveInformation() {
      this.saving = true;
      await this.updateProfile({
        city: this.form.city,
        state: this.form.state,
        zip: this.form.zip,
        diagnosed: this.form.diagnosed,
        insurance: this.form.insurance,
        provider: this.form.provider,
        intervention: this.form.intervention,
        goals: this.form.goals,
        id: this.profileID,
      });
      this.saving = false;
      this.dialog.information = false;
    },
    async saveInterest() {
      if (!this.profile.interests) {
        this.profile.interests = [];
      }
      this.profile.interests.push(this.form.interest);
      this.form.interest = null;

      await this.updateProfile({
        interests: this.profile.interests,
        id: this.profileID,
      });
    },
    async savePicture() {
      this.saving = true;
      await this.updatePicture({
        file: this.form.picture,
        id: this.profileID,
      });
      this.saving = false;
      this.dialog.picture = false;
    },
    async submitShare() {
      this.saving = true;
      this.userFound = await this.shareProfile({
        id: this.profileID,
        email: this.form.share
      });
      this.saving = false;
      if (this.userFound) {
        this.dialog.share = false;
      }
    }
  },
  async mounted() {
    await this.initProfile(this.profileID);
    this.form = {
      about: this.profile.about || null,
      picture: this.profile.picture || null,
      state: this.profile.state || null,
      zip: this.profile.zip || null,
      diagnosed: this.profile.diagnosed || null,
      insurance: this.profile.insurance || null,
      provider: this.profile.provider || null,
      intervention: this.profile.intervention || null,
      goals: this.profile.goals || null,
    };
    this.loading = false;
  },
};
</script>

<style scoped>
.loader {
  margin-top: 20%;
}
</style>
